// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__9-v3N"};